import { useSearchParams } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'

// lucide dropped brand icons; the GitHub mark is inlined instead.
function GithubMark(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" fill="currentColor" aria-hidden {...props}>
      <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82a7.42 7.42 0 0 1 2-.27c.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.01 8.01 0 0 0 16 8c0-4.42-3.58-8-8-8Z" />
    </svg>
  )
}

export default function SignIn() {
  const [searchParams] = useSearchParams()
  const returnTo = searchParams.get('returnTo')
  const signinHref = returnTo
    ? `/api/auth/signin?returnTo=${encodeURIComponent(returnTo)}`
    : '/api/auth/signin'
  return (
    <main className="bg-background grid min-h-screen place-items-center p-6">
      <Card className="w-full max-w-sm">
        <CardContent className="flex flex-col items-center gap-5 px-8 py-10 text-center">
          <img src="/logo.svg" alt="" className="size-10" />
          <div>
            <h1 className="text-base font-semibold">N3O Work</h1>
            <p className="text-muted-foreground mt-1 text-xs">
              Purpose-built views over the engineering work tracker.
            </p>
          </div>
          <Button asChild className="w-full">
            <a href={signinHref}>
              <GithubMark className="size-4" />
              Sign in with GitHub
            </a>
          </Button>
          <p className="text-faint-foreground text-[11px]">
            n3oltd organisation members only.
          </p>
        </CardContent>
      </Card>
    </main>
  )
}
